var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-container"},[_c('div',{staticClass:"hexagon",style:(("color: " + _vm.color + ";"))}),_c('div',{staticClass:"color-label"},[_vm._v(_vm._s(_vm.answer))])])}
var staticRenderFns = []

export { render, staticRenderFns }